// extracted by mini-css-extract-plugin
module.exports = {"label":"IconButton_label__2k52X","icon":"IconButton_icon__33Vww","button":"IconButton_button__29vBa"};